import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

// Tipografías servidas desde el propio paquete: la aplicación no depende de
// ningún dominio externo para renderizarse. Los iconos van como SVG en línea
// (ver presentation/components/ui/iconos.ts).
import '@fontsource-variable/inter';
import '@fontsource-variable/montserrat';
import '@fontsource-variable/jetbrains-mono';

// ─────────────────────────────────────────────────────────────────────────────
// TEMA ACTIVO — cambiar esta línea cambia el diseño de toda la aplicación.
// Ver src/styles/temas/README.md
// ─────────────────────────────────────────────────────────────────────────────
import './styles/temas/clasico.css';
// import './styles/temas/veniot.css';

import './styles/base.css';

import { App } from './App';
import { BarreraError } from './presentation/app/BarreraError';

const contenedor = document.getElementById('root');
if (!contenedor) throw new Error('No se encontró el elemento raíz de la aplicación.');

createRoot(contenedor).render(
  <StrictMode>
    <BarreraError>
      <App />
    </BarreraError>
  </StrictMode>,
);
